import { Update } from './types';

export function getLatestUpdates(limit: number): Update[] {
  const updates = [
    {
      id: '1',
      title: 'MUBS CFSC Leads at CCDR Workshop',
      description: 'Centre contributes key insights to Uganda\'s climate finance strategy at World Bank workshop.',
      date: 'May 9, 2024',
      image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80',
      slug: 'mubs-cfsc-ccdr-workshop'
    },
    {
      id: '2',
      title: 'CAFP Program - Next Cohort',
      description: 'Applications now open for the Climate Adaptation Finance Professional Certificate Program.',
      date: 'March 20, 2024',
      image: '/images/CAFP-Adaptation-Finance.JPG',
      slug: 'cafp-next-cohort'
    }
  ].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  
  return updates.slice(0, limit);
}